
import {API_PATH} from './constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Dialog } from '@capacitor/dialog';




declare function html2pdf(): any;
declare function notify(): any;

export function pdfDocument(element: any, filename: string) :void {
  const opt = {
    margin: 3,
    pagebreak: {mode: ['css']},
    filename: filename,
    image: {type: 'jpeg', quality: 0.98},
    html2canvas: {
      scale: 2,
      imageTimeout: 0,
      useCORS: true,
      // onclone: (element) => {
      //   const svgElements = Array.from(element.querySelectorAll('svg'));
      //   $(svgElements).each(function( i, s: any){
      //     try {
      //       const bBox = $(s).attr('viewBox');
      //       if(bBox){
      //         console.log(bBox,s)
      //       }
      //     }
      //     catch (e) {
      //       console.log(e)
      //     }
      //   })
      // }
    },
  };
  html2pdf().set(opt).from(element).save();
}
export function stripCurrency(text: string): string {
  try {
    return text.replace(/ /g, '').replace('R', '');
  }
  catch (e) {
    return text;
  }
}
export function scrollToItem(section: string,isClass: boolean = false): void {
   // Use querySelector to find the element, which can accept both
  // an ID (e.g., '#myId') or a class (e.g., '.myClass').
  if (isClass) section = `.${section}`;
  else section = `#${section}`;
  const el = document.querySelector(section); 

  if (el) {
    // Scrolls the element into the viewport with a smooth animation.
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Handle fixed headers by adjusting the scroll position after the initial scroll.
    // The browser handles smooth scrolling, so we only need one `scrollIntoView` call
    // and then the offset adjustment.
    const headerOffset = 80; 
    const elementPosition = el.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scroll({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
  // const el = document.getElementById(section);
  // if (el) {
  //   el.scrollIntoView(true);
  //   el.scrollIntoView({behavior: 'smooth'});
  //   const scrolledY = window.scrollY;
  //   if (scrolledY) {
  //     window.scroll({
  //       top: scrolledY - 80,
  //       left: 0,
  //       behavior: 'smooth'
  //     });
  //   }
  // }
}
export function Alert(message : string , wait?: number): any {
  if (!wait) wait = 5000;
  const handle = notify();
  handle.init({
    message: `<strong>${message}</strong>`,
    icon: 'info',   // default: null; options: 'info', 'complete', or any icon-name really
    size: 'lg',     // default: null; options: 'lg'
    style: 'info',  // default: null; options: 'info', 'success',
    close: true,    // default: false (close button enabled, auto-close duration removed)
    speed: 350,     // default: 350 (fade in/out speed)
    duration: wait  // default: 5000 (duration active)
  });
  return handle; // call handle.clear() to dismiss before the duration elapses
}
export function dataURItoBlob(dataURI) {
  var byteString =  atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], {type: mimeString});
}

export const showAlert = async (title: string, message: string) => {
  await Dialog.alert({
    title: title,
    message: message,
  });
};
export const showConfirm = async (title: string, message: string) => {
  const { value } = await Dialog.confirm({
    title: title,
    message: message,
  });
  return value;
};

export const showPrompt = async (title: string, message: string) => {
  const { value, cancelled } = await Dialog.prompt({
    title: title,
    message: message,
  });
  return { "value": value, "cancelled": cancelled };
};
export function getIndex(index: number, dataset: any): any{
  let data =[];
  if (dataset?.length) {
    for (const d of dataset) {
      if (d?.length){
        for (const i of d){
          if (i.index === index){
            data.push(i);
          }
        }
      }
    }
  }
  return data;
};

export function whereEquals(dataset: any[], key: string, value: any): any[] {
  return dataset?.filter((d: any) => d?.[key] === value) ?? [];
};

export function firstWhere(dataset: any[], key: string, value: any): any {
  return dataset?.find((d: any) => d?.[key] === value);
};

export function groupBy(dataset: any[], key: string): any[] {
  const groups: any[] = [];
  for (const d of dataset ?? []) {
    let group = groups.find((g) => g.key === d?.[key]);
    if (!group) {
      group = { key: d?.[key], rows: [] };
      groups.push(group);
    }
    group.rows.push(d);
  }
  return groups;
};

export function getDescription (text: string, index: number): string {
  var t = text.split('|');
  return t[index];
};

